import fetch from './fetch';
import Session from '../services/Session';
var Request = /** @class */ (function () {
    /**
     *
     * @param data
     */
    function Request(data) {
        var _this = this;
        // defaults
        this.blockUI = true;
        this.withCredentials = true;
        var keys = Object.keys(data);
        keys.map(function (key) {
            _this[key] = data[key];
        });
        if (this.withCredentials) {
            if (!this.headers) {
                this.headers = {};
            }
            var jwt = Session.getJWT();
            if (jwt) {
                this.headers['Authorization'] = 'Bearer ' + jwt;
            }
        }
    }
    /**
     *
     * @return {Promise<any>|Promise}
     */
    Request.prototype.execute = function () {
        return fetch(this);
    };
    /**
     *
     * @param apiCall
     */
    Request.prototype.setRequest = function (apiCall) {
        this.apiCall = apiCall;
    };
    return Request;
}());
export default Request;
